export const GUIDES_CATEGORIES = `
  query {
    categories: __type(name: "GuideCategory") {
      enumValues {
        name
      }
    }
  }
`;

export const PAGINATED_GUIDES_QUERY = `
  query paginatedGuides($skip: Int = 0, $first: Int = 30, $target: [Target!] = [Venditore , Compratore]){
    total: guidesConnection(where:{target_in: $target}) {
      aggregate {
        count
      }
    },
    guides: guides(where:{target_in: $target} orderBy: published_DESC, skip: $skip, first: $first){
      id,
      target,
      published,
      publishedAt,
      title
      alternateTitle
      abstract
      imageBlock {
        image {
          handle
        }
        imageAlt
      }
    }
  }
`;

export const PAGINATED_GUIDES_QUERY_BY_CATEGORY = `
  query paginatedGuides($skip: Int = 0, $first: Int = 30, $target: [Target!] = [Venditore , Compratore], $category: GuideCategory!){
    total: guidesConnection(where:{target_in: $target, categories_contains_all: [$category]}) {
      aggregate {
        count
      }
    },
    guides: guides(where: {target_in: $target, categories_contains_all: [$category]} orderBy: published_DESC, skip: $skip, first: $first) {
      id,
      target,
      published,
      publishedAt,
      title,
      alternateTitle,
      abstract,
      categories,
      imageBlock {
        image {
          handle
        }
        imageAlt
      }
    },
    guideSerp: guideSerp(where: {category: $category}) {
      title,
      seo {
        title,
        description
      }
    }
  }
`;

export const RELATED_GUIDES_QUERY = `
  query relatedGuides($skipId: ID, $date: Date, $createdAt: DateTime, $count: Int = 4, $target: [Target!]) {
    older: guides(first: $count, where: { id_not: $skipId, published_lte: $date, createdAt_lt: $createdAt, target_in: $target}, orderBy: published_DESC) {
      id
      publishedAt
      published
      title
      alternateTitle
      abstract
      imageBlock {
        image {
          url(
            transformation: {
              image: { resize: { width: 90, height: 60, fit: crop } }
              document: { output: { format: jpg } }
            }
          )
          handle
        }
        imageAlt
      }
    }
    newer: guides(first: $count, where: { id_not: $skipId, published_gte: $date, createdAt_gt: $createdAt, target_in: $target}, orderBy: published_ASC) {
      id,
      publishedAt
      published
      title
      alternateTitle
      abstract
      imageBlock {
        image {
          url(
            transformation: {
              image: { resize: { width: 90, height: 60, fit: crop } }
              document: { output: { format: jpg } }
            }
          )
          handle
        }
        imageAlt
      }
    }
  }
`;

export const GUIDE_QUERY = `
  query singleGuide($id: ID!, $metaPreviewWidth: Int = 1200 , $metaPreviewHeight: Int = 960) {
    guide(where: { id: $id }) {
      id
      categories
      target
      createdAt
      publishedAt
      published
      title
      alternateTitle
      summaryTitle
      imageBlock {
        image {
          handle
          height
          width
          url
        }
        imageAlt
      }
      metaPreview: imageBlock {
        image {
          url(
            transformation: {
              image: {
                resize: {
                   width: $metaPreviewWidth,
                   height: $metaPreviewHeight,
                   fit: crop
                }
              }
              document: {
                output: { format: jpg }
              }
            }
          )
        }
      }
      abstract
      introduction
      seo {
        title
        description
        keywords
      }
      blocks {
        title
        content
        alternativeTitle
      }
      mainColumn {
        __typename
        ... on AdvFluid {
          id
          advFluidType
          variant
        }
        ... on ArticleBlock {
          id
          title
          alternativeTitle
          content
        }
        ... on SavingCalculator {
          id
          savingCalculatorType
          title
          description
          priceLabel
          claim
          cta
        }
        ... on EvaluationLeadWizard {
          id
          title
          description
        }
      }
      rightColumn {
        __typename
        ... on AdvFluid {
          advFluidType
          variant
        }
      }
    }
  }
`;

export const GUIDES_BY_IDS = `
  query guidesByIds($ids: [ID!]!) {
    guides(where: { id_in: $ids }) {
      id
      categories
      target
      title
      alternateTitle
      abstract
      imageBlock {
        image {
          handle
          height
          width
          url
        }
        imageAlt
      }
      createdAt
      publishedAt
      published
    }
  }
`;

export const FEATURED_GUIDES_QUERY = `
 query featuredGuides($count: Int = 4) {
    featured: guides(first: $count, where: { target_not: Agente, featured: true}, orderBy: published_DESC) {
      id
      publishedAt
      published
      title
      alternateTitle
      abstract
      imageBlock {
        image {
          url(
            transformation: {
              image: { resize: { width: 90, height: 60, fit: clip } }
              document: { output: { format: jpg } }
            }
          )
          handle
        }
        imageAlt
      }
    }
  }
`;
